const getDefaultQuotationNo = () => {
  const now = new Date();
  const year = now.getFullYear().toString().slice(-2);
  const month = (now.getMonth() + 1).toString().padStart(2, '0');
  const day = now.getDate().toString().padStart(2, '0');
  return `${year}${month}${day}`;
};

export const demoData = {
  quotationNo: getDefaultQuotationNo(),
  clientName: 'Energy Solutions International Ltd.',
  clientAddress: '123 Power Street\nIndustrial Zone\nDubai, UAE',
  clientEmail: 'procurement@energysolutions.ae',
  plantTitle: '4 x MWM 2032V16',
  plantCapacity: '17.2 MW',
  engineManufacturer: 'MWM',
  engineType: '4 x MWM 2032V16',
  engineOutput: '4,300',
  yearBuilt: '2020',
  workingHours: '15,000',
  alternatorType: 'AVK DIG 156 L6',
  voltage: '11',
  frequency: '50Hz',
  powerRating: '5,000 KVA',
  speed: '1500',
  fuelType: 'Natural Gas',
  price: 'EUR 4,750,000',
  paymentTerms: '30% advance payment upon contract signing\n60% upon delivery\n10% after commissioning',
  deliveryTime: 'Ex-stock installed in Power Plant',
  scopeOfSupply: [
    {
      description: '4 x MWM 2032V16 Generating Sets',
      quantity: '4',
      unit: 'Set'
    },
    {
      description: 'Engine Radiator',
      quantity: '4',
      unit: 'Unit'
    },
    {
      description: 'Jacket Water Radiator',
      quantity: '4',
      unit: 'Unit'
    },
    {
      description: 'After Cooler Radiator',
      quantity: '4',
      unit: 'Unit'
    },
    {
      description: 'Silencer Muffler Exhaust Engine',
      quantity: '4',
      unit: 'Set'
    },
    {
      description: 'Zero Pressure unit (Gas Control System)',
      quantity: '1',
      unit: 'Lot'
    },
    {
      description: 'Cooling Water Pump HT',
      quantity: '4',
      unit: 'Unit'
    },
    {
      description: 'Expansion Vessel Tank HT',
      quantity: '4',
      unit: 'Unit'
    },
    {
      description: 'Panel FUS',
      quantity: '1',
      unit: 'Lot'
    },
    {
      description: 'Panel TEM',
      quantity: '1',
      unit: 'Lot'
    },
    {
      description: 'Panel Medium Voltage (MV)',
      quantity: '1',
      unit: 'Set'
    },
    {
      description: 'Transformer Step Down',
      quantity: '2',
      unit: 'Unit'
    },
    {
      description: 'Cable Control Systems',
      quantity: '1',
      unit: 'Lot'
    },
    {
      description: 'Metering Gas Equipment',
      quantity: '1',
      unit: 'Set'
    },
    {
      description: 'Commissioning and Testing',
      quantity: '1',
      unit: 'Service'
    },
    {
      description: 'Training and Documentation',
      quantity: '1',
      unit: 'Package'
    },
    {
      description: 'Spare Parts Package (2 Years)',
      quantity: '1',
      unit: 'Package'
    }
  ],
  additionalNotes: 'This quotation is valid for 30 days from the date of issue.\n\nAll equipment is offered in good working condition with complete documentation.\n\nWarranty: 12 months from commissioning or 18 months from delivery, whichever comes first.',
  images: [],
  companyDetails: {
    name: 'Atlantis Marine and Power Solution FZ-LLC',
    addressLine1: 'S32-16 Shed No.32 - TP Al Hamra FZ',
    addressLine2: 'Al Hamra Industrial Zone-FZ',
    addressLine3: 'RAK, United Arab Emirates',
    email: 'info@atlantismarine.ae'
  },
  watermarkImage: null,
  logoImage: null
}; 